document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.testimonial-section' ).forEach( ( section ) => {
		const slides  = Array.from( section.querySelectorAll( '.testimonial-section__slide' ) );
		const arrows  = section.querySelector( '.testimonial-section__arrows' );
		const prevBtn = section.querySelector( '.testimonial-section__arrow--prev' );
		const nextBtn = section.querySelector( '.testimonial-section__arrow--next' );
		const isNoCS  = section.classList.contains( 'testimonial-section--no-case-study' );

		if ( slides.length <= 1 ) return;

		let activeIndex = 0;

		// Cards visible at once: the case-study layout always shows one slide;
		// the no-case-study grid shows 1 / 2 / 3 by viewport width.
		function getCardsPerView() {
			if ( ! isNoCS ) return 1;
			const w = window.innerWidth;
			if ( w < 768 ) return 1;
			if ( w < 1024 ) return 2;
			return 3;
		}

		// Highest valid start index. 0 means every slide already fits in view
		// (e.g. 3 cards in the 3-up desktop grid) so no paging is needed.
		function getMaxStart() {
			return Math.max( 0, slides.length - getCardsPerView() );
		}

		function showSlides( startIndex ) {
			const perView  = getCardsPerView();
			const maxStart = getMaxStart();

			// Clamp into range — goNext()/goPrev() own the wrap-around.
			activeIndex = Math.min( Math.max( startIndex, 0 ), maxStart );

			slides.forEach( ( slide, i ) => {
				const visible = i >= activeIndex && i < activeIndex + perView;
				slide.classList.toggle( 'is-active', visible );
			} );

			// Hide the arrows entirely when there is nothing to page to.
			// `maxStart` is viewport-aware, so this re-evaluates on resize:
			// arrows show on desktop only once there are more than 3 cards,
			// on tablet more than 2, on mobile more than 1.
			if ( arrows ) arrows.hidden = maxStart === 0;
		}

		// Advance one page. At the last page wrap to the start; otherwise step
		// forward by one view, clamped to maxStart so a partial final page
		// (e.g. 4 cards in the 3-up grid → start index 1) is never skipped.
		function goNext() {
			const maxStart = getMaxStart();
			const target = activeIndex >= maxStart
				? 0
				: Math.min( activeIndex + getCardsPerView(), maxStart );
			showSlides( target );
		}

		// Step back one page. At the first page wrap to the last; otherwise
		// step back by one view, clamped to 0.
		function goPrev() {
			const maxStart = getMaxStart();
			const target = activeIndex <= 0
				? maxStart
				: Math.max( activeIndex - getCardsPerView(), 0 );
			showSlides( target );
		}

		showSlides( 0 );

		if ( prevBtn ) prevBtn.addEventListener( 'click', goPrev );
		if ( nextBtn ) nextBtn.addEventListener( 'click', goNext );

		let resizeTimer;
		window.addEventListener( 'resize', () => {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( () => showSlides( activeIndex ), 150 );
		} );
	} );
} );
